import {Injectable} from '@angular/core';
import {MinizaemApiClientService} from "../../core/services/minizaem-api-client.service";
import {Observable} from "rxjs";
import {StaticPage} from "../models/static-page";
import {EasyFinancePaymentAccount} from "../models/easy-finance-payment-account";
import {DiscountBox} from "../models/discount-box";


@Injectable({
  providedIn: 'root'
})
export class StaticPageService extends MinizaemApiClientService {

  getBySlugFromApi(slug: string): Observable<StaticPage> {
    return this.http.get<StaticPage>(this.buildURI(`api/static-page/show/${slug}`));
  }

  getEasyfinancePaymentAccountsFromApi(): Observable<EasyFinancePaymentAccount[]> {
    return this.http.get<EasyFinancePaymentAccount[]>(this.buildURI(`api/easy-finance-payment-account/show`));
  }

  getDiscountBoxesFromApi(): Observable<DiscountBox[]> {
    return this.http.get<DiscountBox[]>(this.buildURI(`api/discount-box/show`));
  }
}
